import React from "react";
import LandingPage from "../../Components/services/color-correction/LandingPage";
import Navbar from "../../Components/Navbar";
import Footer from "../../Components/Footer";
import Faqs from "../../Components/services/color-correction/Faqs";
// import WhyUs from "../../Components/services/color-correction/WhyUs";
const ColorCorrection = () => {
  return (
    <>
      <Navbar />
      <LandingPage />
      {/* <WhyUs /> */}
      <Faqs />
      <Footer />
    </>
  );
};

export default ColorCorrection;
